module.exports = __webpack_public_path__ + "static/media/warning.6a751f03.svg";